import React, { useState } from 'react';
import Drawer from '../../../../../component/Drawer';
import dateIcon from '../../../../../assets/image/date-schedule-icon.svg';
import editIcon from '../../../../../assets/image/edit-icon.png';
import reportPdfIcon from '../../../../../assets/image/report-pdf-icon.svg';
import arrowForwardIcon from '../../../../../assets/image/arrow-forward-icon.svg';
import Button from '../../../../../component/ui/Button';

export default function ReportScheduledDrawer({ isOpen, onClose, id }) {
	const [activeTab, setActiveTab] = useState('Schedule History');
	const navTabs = ['Schedule History', 'Activity'];

	const renderTabContent = () => {
		switch (activeTab) {
			case 'Schedule History':
				return <></>;
			case 'Activity':
				return <></>;
			default:
				return null;
		}
	};
	return (
		<Drawer
			handleViewMoreDetails={''}
			isOpen={isOpen}
			onClose={onClose}
			title={'Scheduled Report'}
		>
			<br />

			<div
				className="d-flex justify-content-start align-items-start p-3 gap-4 rounded"
				style={{ background: '#F6F6F9', boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.05)' }}
			>
				<img
					width={40}
					height={40}
					src={dateIcon}
					alt="date-icon"
				/>
				<div className="align-items-start">
					<div className="fs-4 fw-light">{'The next schedule report will be sent on '}</div>
					<div className="fs-4 fw-light mt-1 mb-3">{'15/04/2026  01:30 PM'}</div>
					<div className="d-flex justify-content-start">
						<Button
							type="button"
							className="mt-0 btn btn-gray"
							button="Pause Schedule"
							onClick={() => {}}
						/>
					</div>
				</div>
			</div>
			<br />
			<hr />
			<div className="d-flex justify-content-start align-items-center gap-4">
				<div className="fs-4 fw-bold text-dark">Schedule Details</div>
				<img
					width={20}
					height={20}
					src={editIcon}
					className="cursor-pointer"
					alt="edit-icon"
				/>
			</div>
			<hr />
			<div className="d-flex justify-content-start align-items-center gap-4 py-3">
				<div className="w-150 fs-4 fw-semibold">Frequency</div>
				<div className="fs-4 fw-light">:</div>
				<div className="fs-4 fw-light">Weekly</div>
			</div>
			<div className="d-flex justify-content-start align-items-center gap-4 py-3">
				<div className="w-150 fs-4 fw-semibold">Start Date</div>
				<div className="fs-4 fw-light">:</div>
				<div className="fs-4 fw-light">15/04/2026 01:30 PM</div>
			</div>
			<div className="d-flex justify-content-start align-items-center gap-4 py-3">
				<div className="w-150 fs-4 fw-semibold">Format</div>
				<div className="fs-4 fw-light">:</div>
				<img
					width={20}
					height={20}
					src={reportPdfIcon}
					alt="format-icon"
				/>
				<div className=" fs-4 fw-light">PDF</div>
			</div>
			<div
				className="d-flex justify-content-start align-items-center gap-4 py-3 cursor-pointer"
				onClick={() => {}}
			>
				<div className="fs-4 fw-semibold">Show Recipients</div>
				<img
					width={12}
					height={12}
					src={arrowForwardIcon}
					alt="arrow-icon"
				/>
			</div>
			<br />
			<hr />

			{/* tabs  */}
			<div>
				<ul className="nav mb-4 mt-2">
					{navTabs.map((item, index) => (
						<li
							key={index}
							className="nav-item"
						>
							<div
								className={`nav-link ${activeTab === item && 'active'} cursor-pointer`}
								onClick={(e) => {
									e.preventDefault();
									setActiveTab(item);
								}}
							>
								{item}
							</div>
						</li>
					))}
				</ul>
				<hr
					style={{
						backgroundColor: '#E3E4E5',
						boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
						marginTop: '-5px',
					}}
				/>
				<div>{renderTabContent()}</div>
			</div>
		</Drawer>
	);
}
